import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/kenneth/Sites/typebrigade/typebrigade.com/src/components/TemplateBlogPost.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Type Brigade is a community event for learning, meeting, and collaborating within the Vancouver type community.`}</p>
    <p>{`We value the participation of each member of our community, and want all attendees to have an enjoyable, fulfilling experience. All attendees, speakers, exhibitors, volunteers are expected to treat others with respect and courtesy. In short: `}<strong parentName="p">{`be kind to others. Don’t be a jerk.`}</strong></p>
    <p>{`In an effort to make expectations clear and help mitigate potential problems, the specifics of this have been outlined in the following Code of Conduct.`}</p>
    <h1>{`Code of Conduct`}</h1>
    <p>{`Be kind to others. Don’t be a jerk.`}</p>
    <h2>{`The long version`}</h2>
    <p>{`As a design-centred event, the importance of empathy, perception and effective communication will be familiar to many attendees. Type Brigade asks that you continue using these skills during the event: please be mindful of the words you use. Exclusionary jokes—sexist, racist, or otherwise—will be offensive to those around you, and will not be considered appropriate.`}</p>
    <p>{`Communication should be appropriate for a professional audience, including people of many different backgrounds. Sexual language and imagery is not appropriate for the meetup, including during talks. It is becoming more common for type or designed visuals to be described using sexual language, but we ask speakers and attendees refrain from participating in this trend.`}</p>
    <p>{`Type Brigade is dedicated to providing a harassment-free conference experience for everyone, regardless of gender, sexual orientation, disability, physical appearance, body size, race, or religion. We do not tolerate harassment of conference participants in any form.`}</p>
    <p>{`Harassment includes offensive verbal comments related to gender, sexual orientation, disability, physical appearance, body size, race, religion, sexual images in public spaces, deliberate intimidation, stalking, following, harassing, photography or recording, sustained disruption of talks, inappropriate physical contact, and unwelcome sexual attention.`}</p>
    <p>{`Participants asked to stop any harassing behaviour are expected to comply immediately.`}</p>
    <p>{`Attendees violating the Code of Conduct may be asked to leave the event at the sole discretion of the conference organisers, and reserve the right to refuse them entrance to future events.`}</p>
    <p>{`Thank you for helping make this a welcoming, friendly event for all!`}</p>
    <h2>{`Contributing`}</h2>
    <p>{`Our Code of Conduct `}<a parentName="p" {...{
        "href": "https://github.com/typebrigade/typebrigade.com/edit/master/code-of-conduct.md"
      }}>{`is editable and maintained`}</a>{` by the Type Brigade community. You’ll need a `}<a parentName="p" {...{
        "href": "https://github.com/typebrigade/typebrigade.com/edit/master/code-of-conduct.md"
      }}>{`GitHub account`}</a>{` to make changes, and can `}<a parentName="p" {...{
        "href": "mailto:kenneth@typebrigade.com"
      }}>{`email the organisers`}</a>{` if you’d like any help setting this up.`}</p>
    <h2>{`License`}</h2>
    <p><a parentName="p" {...{
        "href": "http://creativecommons.org/licenses/by/3.0"
      }}>{`Creative Commons Attribution 3.0 Unported License`}</a></p>
    <p>{`This document is based upon the `}<a parentName="p" {...{
        "href": "https://us.pycon.org/2012/codeofconduct/"
      }}>{`PyCon Code of Conduct`}</a>{`, the `}<a parentName="p" {...{
        "href": "https://github.com/PDXNode/pdxnode/blob/master/code-of-conduct.md#code-of-conduct"
      }}>{`PDXNode code of Conduct`}</a>{`, and the `}<a parentName="p" {...{
        "href": "http://confcodeofconduct.com/"
      }}>{`Conference Code of Conduct`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      